import { gsap } from 'gsap'

// Small GSAP-powered reward effects shared by the practice views.
// All of them are fire-and-forget and clean up their own DOM.

const CONFETTI_COLORS = ['#6ee7b7', '#fbbf24', '#60a5fa', '#f472b6', '#a78bfa', '#34d399']

// Confetti burst at a screen position (e.g. where the user tapped the
// correct answer). Pieces fly out, tumble, and fall under fake gravity.
export function celebrate(x, y, opts = {}) {
  const { count = 26, spread = 150 } = opts
  const layer = document.createElement('div')
  layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:4000;overflow:hidden'
  document.body.appendChild(layer)

  let finished = 0
  for (let i = 0; i < count; i++) {
    const piece = document.createElement('div')
    const size = 5 + Math.random() * 7
    const round = Math.random() > 0.6
    piece.style.cssText = [
      'position:absolute',
      `left:${x}px`, `top:${y}px`,
      `width:${size}px`, `height:${round ? size : size * 0.45}px`,
      `background:${CONFETTI_COLORS[i % CONFETTI_COLORS.length]}`,
      `border-radius:${round ? '50%' : '2px'}`,
    ].join(';')
    layer.appendChild(piece)

    const angle = Math.random() * Math.PI * 2
    const velocity = spread * (0.4 + Math.random())
    const dx = Math.cos(angle) * velocity
    const dy = Math.sin(angle) * velocity - spread * 0.6
    gsap.to(piece, {
      keyframes: [
        { x: dx * 0.7, y: dy * 0.7, rotation: Math.random() * 360, duration: 0.35, ease: 'power2.out' },
        { x: dx, y: dy + spread * 1.5, rotation: `+=${180 + Math.random() * 360}`, opacity: 0, duration: 0.8, ease: 'power1.in' },
      ],
      onComplete: () => { if (++finished === count) layer.remove() },
    })
  }
}

// Quick scale pop — streak counter ticking up, a word being hit, etc.
export function popScale(el, scale = 1.4) {
  if (!el) return
  gsap.fromTo(el, { scale: 1 }, { scale, duration: 0.14, yoyo: true, repeat: 1, ease: 'power2.out', clearProps: 'scale' })
}

// Horizontal shake for wrong answers.
export function shake(el) {
  if (!el) return
  gsap.fromTo(el, { x: 0 }, {
    keyframes: [
      { x: -9, duration: 0.05 }, { x: 9, duration: 0.05 },
      { x: -6, duration: 0.05 }, { x: 6, duration: 0.05 },
      { x: 0, duration: 0.05 },
    ],
    clearProps: 'x',
  })
}

// Springy entrance for a card/question that just changed.
export function enterUp(el) {
  if (!el) return
  gsap.fromTo(el,
    { y: 26, opacity: 0, scale: 0.97 },
    { y: 0, opacity: 1, scale: 1, duration: 0.5, ease: 'back.out(1.6)', clearProps: 'transform,opacity' }
  )
}
